import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  padding: 24px 16px 120px 16px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

export const Login = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;

  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

export const LoginButton = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  align-self: stretch;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 12px;
`;

export const SectionTitleOptional = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 2px;

  color: rgba(0, 25, 54, 0.31);
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

export const SectionTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  position: relative;
`;

export const TextInput = styled.input<{ $error?: boolean; $success?: boolean }>`
  display: flex;
  height: 50px;
  padding: 4px 16px;
  align-items: center;
  min-width: 0;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  background: #fff;
  outline: none;

  color: #000c1ecc;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;

  &::placeholder {
    color: rgba(0, 25, 54, 0.31);
  }

  &:focus {
    border-color: #008aff;
  }

  ${({ $error }) =>
    $error &&
    css`
      border-color: #f04452;
    `}

  ${({ $success }) =>
    $success &&
    css`
      background: #70737c14;
      color: #00193631;

      &:focus {
        border-color: #008aff;
        background: #f7f8fc;

        color: #000c1ecc;
      }
    `}
`;

type ConfirmButtonProps = {
  $disabled?: boolean;
  $isRecent?: boolean;
};

export const InputConfirmButton = styled.button<ConfirmButtonProps>`
  display: flex;
  width: 118px;
  /* padding: 12px 16px; */
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid;

  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;

  border: 1px solid #008aff;
  background: #fff;
  color: #008aff;
  cursor: pointer;

  ${({ $disabled }) =>
    $disabled &&
    css`
      border-radius: 8px;
      border: 1px solid #e5e8ea;
      background: rgba(2, 32, 71, 0.05);
      color: #0019364f;
      cursor: default;
      pointer-events: none;
    `}

  ${({ $isRecent }) =>
    $isRecent &&
    css`
      background: #e7f0fe;
      border: 1px solid #e5e8ea;
    `}
  

  &:hover {
    background: ${({ $isRecent }) => ($isRecent ? '#D5E6FF' : '#e7f0fe')};
  }
`;

export const FeedbackArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const Feedback = styled.div<{ $error?: boolean; $success?: boolean }>`
  flex: 1 0 0;
  color: #6b7684;
  font-size: 13px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
  white-space: pre-line;

  ${({ $error }) => $error && 'color: #F04452'};
  ${({ $success }) => $success && 'color: #008AFF'};
`;

export const IconWrapper = styled.div`
  padding-top: 2px;
`;

export const PasswordSuccessIcon = styled.img`
  position: absolute;
  top: 13px;
  right: 16px;
`;

export const TimeLeftLabel = styled.div`
  color: #6b7684;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

export const TermsBox = styled.div`
  display: flex;
  padding: 12px 20px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
  background: #fff;
`;

export const TermsRow = styled.div`
  display: flex;
  flex-direction: row;
  padding: 12px 0;
  gap: 8px;
  align-self: stretch;
  cursor: pointer;
  user-select: none;
`;

export const AllAgree = styled.div`
  color: rgba(0, 12, 30, 0.8);
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

export const AllAgreeCheckbox = styled.div<{ $checked?: boolean }>`
  display: flex;
  width: 24px;
  height: 24px;
  border: 2px solid;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  border-radius: 4px;
  border-color: ${({ $checked }) => ($checked ? '#008AFF' : '#37383C29')};
  background-color: ${({ $checked }) => $checked && '#008AFF'};
`;

export const TermsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
`;

export const Checkbox = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 2px solid rgba(55, 56, 60, 0.16);
  cursor: pointer;
`;

export const TermsContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  user-select: none;
`;

export const TermsValue = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
  flex: 1 0 0;
  cursor: pointer;

  color: #6b7684;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;

  & > span {
    color: #f04452;
  }
`;

export const SeeMoreButton = styled.img`
  cursor: pointer;
`;

export const Divider = styled.div`
  height: 1px;
  align-self: stretch;
  background: #e1e2e4;
`;

export const SignupButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  user-select: none;

  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;

  cursor: pointer;
  outline: none;
  border: none;
  background: #008aff;
  color: #fff;

  ${({ $disabled }) =>
    $disabled &&
    css`
      background: #f7f7f8;
      color: #37383c29;
      cursor: default;
      pointer-events: none;
    `}
`;
